import * as CuepointPreviewActions from "actions/CuepointPreviewActions";
import * as PlaybackStateActions from "actions/PlaybackStateActions";
import CuepointDot from "components/CuepointDots/CuepointDot";
import getIsMobile from "selectors/device/getIsMobile";
import getShowFullscreenCuepointPreviews from "selectors/breakpoint/getShowFullscreenCuepointPreviews";
import makeGetChapterEntity from "selectors/chapter/makeGetChapterEntity";
import makeGetCuepointBuckets from "selectors/cuepoint/makeGetCuepointBuckets";
import { connect } from "react-redux";
import get from "lodash/get";
import pick from "lodash/pick";
import { WithSliderDimensions } from "context/Slider";
import { compose, fromRenderProps } from "recompose";

const makeMapStateToProps = () => {
  const getChapterEntity = makeGetChapterEntity();
  const getCuepointBuckets = makeGetCuepointBuckets();

  return (state, ownProps) => {
    const chapter = getChapterEntity(state, ownProps);
    const buckets = getCuepointBuckets(state, ownProps);
    const startTime = get(buckets, [ownProps.cuepointIndex, "startTime"], 0);
    const isMobile = getIsMobile(state, ownProps);
    return {
      allowMouseEvents: !isMobile,
      allowTapEvents: isMobile,
      isActive: state.cuepointPreviews.visibleIndex === ownProps.cuepointIndex,
      percentStartTime: Math.round((startTime / chapter.duration) * 100),
      showPreviewOnClick:
        getShowFullscreenCuepointPreviews(state, ownProps) || isMobile,
      showPreviewOnHover:
        !getShowFullscreenCuepointPreviews(state, ownProps) && !isMobile,
      startTime,
    };
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleHidePreview: () =>
    dispatch(CuepointPreviewActions.hideCuepointPreviews()),
  handleShowPreview: () =>
    dispatch(
      CuepointPreviewActions.setVisibleCuepointPreviewIndex(
        ownProps.cuepointIndex,
      ),
    ),
  onSeekClick: (time) =>
    dispatch(
      PlaybackStateActions.changePlaybackState(ownProps, {
        time,
      }),
    ),
});

const mergeProps = (stateProps, dispatchProps) => ({
  ...pick(stateProps, ["startTime", "percentStartTime"]),
  onMouseEnter: () => {
    if (stateProps.allowMouseEvents && stateProps.showPreviewOnHover) {
      dispatchProps.handleShowPreview();
    }
  },
  onMouseLeave: () => {
    if (stateProps.allowMouseEvents && stateProps.showPreviewOnHover) {
      dispatchProps.handleHidePreview();
    }
  },
  onMouseDown: () => {
    if (!stateProps.allowMouseEvents) {
      return;
    }

    if (stateProps.showPreviewOnClick) {
      if (stateProps.isActive) {
        dispatchProps.handleHidePreview();
      } else {
        dispatchProps.handleShowPreview();
      }
    } else {
      dispatchProps.onSeekClick(stateProps.startTime);
    }
    return false; //prevent handleTap since it is already handled.
  },
  onTap: () => {
    if (!stateProps.allowTapEvents) {
      return;
    }

    if (stateProps.isActive) {
      dispatchProps.handleHidePreview();
    } else {
      dispatchProps.handleShowPreview();
    }
  },
});

export default compose(
  fromRenderProps(WithSliderDimensions, ({ sliderDimensions }) => ({
    sliderWidth: sliderDimensions.width,
  })),
  connect(makeMapStateToProps, mapDispatchToProps, mergeProps),
)(CuepointDot);
